import { License } from '~/gen/proto/bff/v1/model_pb'

export function isUserRoleConfigurable(licenses: License[]): boolean {
  return licenses.some((v) => {
    return v.isProductPublic && v.isUserRoleConfigurable
  })
}
